import React from 'react';
import { AuthenticationContext } from '../../authentication/consts';

const AuthenticationContextConnect = (OriginalComponent) => (props) => {
	return (
		<AuthenticationContext.Consumer>
			{({ saveEmailForForgotPassword, forgotPasswordEmail }) => (
				<OriginalComponent
					{...props}
					setPreviewLoginFormEmail={saveEmailForForgotPassword}
					forgotPasswordEmail={forgotPasswordEmail}
				/>
			)}
		</AuthenticationContext.Consumer>
	);
};

export default AuthenticationContextConnect;
